import { render, staticRenderFns } from "./BaseDivider.vue?vue&type=template&id=1000f8a0&"
import script from "./BaseDivider.vue?vue&type=script&lang=js&"
export * from "./BaseDivider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports